/* Titan League · arregla el visor para paquetes y productos físicos */
(function () {
  if (window.__titanModalFix) return;
  window.__titanModalFix = true;

  var INFO = {
    'paquete-kitsune-dlc-premium': {
      kind: 'fisico',
      title: 'Paquete Kitsune + DLC Premium',
      rarity: 'Producto físico · Envío a domicilio',
      html: '<strong>📦 Te llega a tu casa por paquetería</strong><br>' +
        'Caja Kitsune reutilizable con <b>7 artículos</b>: 2 peluches, 2 minifiguras, póster coleccionable y un <b>código DLC Premium</b> para canjear en Roblox.<br>' +
        'Producto oficial de PhatMojo, Serie 3. Edad 6+, contiene piezas pequeñas.<br>' +
        '<span style="color:#8f86a6;font-size:12px">Al pagar te pedimos tu dirección de envío. No necesitas usuario de Roblox: el código viene dentro de la caja.</span>'
    },
    'paquete-mini-titan': { kind: 'pack', title: 'Paquete Mini Titán', rarity: 'Paquete · Entrega por gifting',
      html: '<strong>🎁 Incluye 3 artículos</strong><br>Magma permanente · 2x Mastery · Fast Boats<br><span style="color:#8f86a6;font-size:12px">Se entregan por gifting al usuario que escribas. Al ser varios artículos puede tardar un poco más.</span>' },
    'paquete-pvp-titan': { kind: 'pack', title: 'Paquete PvP Titán', rarity: 'Paquete · Entrega por gifting',
      html: '<strong>🎁 Incluye 3 artículos</strong><br>Portal permanente · Dark Blade · 2x Mastery<br><span style="color:#8f86a6;font-size:12px">Se entregan por gifting al usuario que escribas. Al ser varios artículos puede tardar un poco más.</span>' },
    'paquete-farmeo-titan': { kind: 'pack', title: 'Paquete Farmeo Titán', rarity: 'Paquete · Entrega por gifting',
      html: '<strong>🎁 Incluye 3 artículos</strong><br>Dough permanente · 2x Money · Fruit Notifier<br><span style="color:#8f86a6;font-size:12px">Se entregan por gifting al usuario que escribas. Al ser varios artículos puede tardar un poco más.</span>' },
    'paquete-titan-super': { kind: 'pack', title: 'Paquete Titán Súper', rarity: 'Paquete · Entrega por gifting',
      html: '<strong>🎁 Incluye 4 artículos</strong><br>Dragón permanente · Dark Blade · 2x Mastery · +1 Fruit Storage<br><span style="color:#8f86a6;font-size:12px">Se entregan por gifting al usuario que escribas. Al ser varios artículos puede tardar un poco más.</span>' }
  };

  var last = null;
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('.tlf2-card[data-handle]');
    if (c) last = c;
  }, true);

  function infoOf() { return last ? INFO[last.getAttribute('data-handle')] : null; }

  function fields(modal, show) {
    var f = modal.querySelector('.tlf2-field');
    var chk = modal.querySelector('.tlf2-check');
    var np = modal.querySelector('.tlf2-no-pass');
    [f, chk, np].forEach(function (n) { if (n) n.style.display = show ? '' : 'none'; });
  }

  function apply() {
    var modal = document.getElementById('tlf2-modal');
    if (!modal || modal.className.indexOf('open') < 0 || !last) return;
    var info = infoOf();
    var status = modal.querySelector('.tlf2-status');
    if (status) status.textContent = '';
    if (!info) { fields(modal, true); return; }
    var n = document.getElementById('tlf2-modal-name');
    var r = document.getElementById('tlf2-modal-rarity');
    var g = modal.querySelector('.tlf2-gift');
    var btn = modal.querySelector('.tlf2-checkout');
    if (n) n.textContent = info.title;
    if (r) r.textContent = info.rarity;
    if (g) g.innerHTML = info.html;
    if (info.kind === 'fisico') {
      fields(modal, false);
      if (btn) { btn.disabled = false; btn.textContent = 'Comprar ahora'; }
    } else {
      fields(modal, true);
    }
  }

  function addFisico(info, handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var v = p.variants && p.variants[0];
        if (!v) throw new Error('variant');
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: v.id, quantity: 1, properties: { 'Artículo seleccionado': info.title, 'Método de entrega': 'Envío a domicilio' } }] };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok || d.status) throw new Error('cart');
            return d;
          });
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#tlf2-modal .tlf2-checkout');
    if (!btn) return;
    var info = infoOf();
    if (!info || info.kind !== 'fisico') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var modal = document.getElementById('tlf2-modal');
    var status = modal.querySelector('.tlf2-status');
    btn.disabled = true;
    btn.textContent = 'Abriendo pago…';
    if (status) status.textContent = '';
    addFisico(info, last.getAttribute('data-handle'))
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        if (status) status.textContent = 'No pudimos preparar el pago. Inténtalo de nuevo.';
        btn.disabled = false;
        btn.textContent = 'Comprar ahora';
      });
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#tlf2-modal .tg-addcart');
    if (!btn) return;
    var info = infoOf();
    if (!info || info.kind !== 'fisico') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var modal = document.getElementById('tlf2-modal');
    var status = modal.querySelector('.tlf2-status');
    var txt = btn.querySelector('.tg-cart-txt');
    btn.disabled = true;
    if (txt) txt.textContent = 'Agregando…';
    if (status) status.textContent = '';
    var handle = last.getAttribute('data-handle');
    var img = last.getAttribute('data-img');
    var srcEl = modal.querySelector('.tlf2-model img') || last.querySelector('.tlf2-art img');
    addFisico(info, handle)
      .then(function (d) {
        if (txt) txt.textContent = '¡Agregado!';
        if (window.TitanFX && window.TitanFX.flyToCart) window.TitanFX.flyToCart(srcEl, img);
        var drawer = document.querySelector('cart-drawer');
        setTimeout(function () {
          var close = modal.querySelector('.tlf2-close');
          if (close) close.click();
          if (drawer && d.sections && drawer.renderContents) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(d);
          }
          btn.disabled = false;
          if (txt) txt.textContent = 'Agregar al carrito';
        }, 700);
      })
      .catch(function () {
        if (status) status.textContent = 'No pudimos agregarlo al carrito. Inténtalo de nuevo.';
        btn.disabled = false;
        if (txt) txt.textContent = 'Agregar al carrito';
      });
  }, true);

  function start() {
    var m = document.getElementById('tlf2-modal');
    if (!m) return setTimeout(start, 300);
    new MutationObserver(function () { setTimeout(apply, 40); })
      .observe(m, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
